import LatestNewsBlock from 'app/features/success/latestNewsBlock/components/LatestNewsBlock';

export default LatestNewsBlock;
